import jsPDF from "jspdf";
import QRCode from "qrcode";
import {interRegular} from './InterVariable-normal.js';

export async function getImageDataURL(url) {
  const response = await fetch(url, {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    headers: {
      Origin: window.location.origin,
    },
  });
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });
}

export async function makeCircularImage(imageDataUrl, size, scaleFactor = 16) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const image = new Image();

    canvas.width = size * scaleFactor;
    canvas.height = size * scaleFactor;

    image.onload = () => {
      try {
        context.beginPath();
        context.arc(
          (size * scaleFactor) / 2,
          (size * scaleFactor) / 2,
          (size * scaleFactor) / 2,
          0,
          2 * Math.PI,
          false
        );
        context.clip();
        context.drawImage(image, 0, 0, size * scaleFactor, size * scaleFactor);
        const circularImageDataUrl = canvas.toDataURL("image/png");
        resolve(circularImageDataUrl);
      } catch(err) {
        reject(err);
      }
    };
    image.src = imageDataUrl;
  });
}

function centeredText(doc, text, y, angle = 0) {
  const pageWidth = doc.internal.pageSize.width;
  const textWidth =
    -doc.getStringUnitWidth(text) * doc.internal.getFontSize() * 0.3527;

  const xPos = (pageWidth - textWidth) / 2;
  const yPos = angle === 180 ? 2 * y - y : y;

  doc.text(text, xPos, yPos, { angle });
}

export async function generatePDF(data, imageDataUrl, eelj, ticket_id, ebarimt) {
  const canvas = await QRCode.toCanvas(
    `https://nairamdal.mn/profile/${data.id}`
  );


  const imageData = canvas.toDataURL("image/png");
  
  const header = "/ticket_headerlambo.png";
  // const profile = await makeCircularImage(imageDataUrl, 30);
  
  // Load font
  await interRegular();

  const doc = new jsPDF({ format: [54, 200] });
  doc.setFont("Inter");

  const firstName =
    data.firstName.charAt(0).toUpperCase() + data.firstName.slice(1);
  const lastName =
    data.lastName.charAt(0).toUpperCase() + data.lastName.slice(1);
  const fullname = `${lastName} ${firstName}`;
  const pageWidth = doc.internal.pageSize.width;
  const eeljTitle = eelj.title.charAt(0).toUpperCase() + eelj.title.slice(1);
  const eeljStartDate = new Date(eelj.start_date).toISOString().split('T')[0];
  const eeljEndDate = new Date(eelj.end_date).toISOString().split('T')[0];
  const register = data.registerNumber;
  const id = data.id;

  doc.setFontSize(8);
  doc.setFont("Inter", "normal");

  const ticket_number = `Тасалбар № ${ticket_id}`;
  const idWidth = doc.getStringUnitWidth(ticket_number) * 8 * 0.3527;
  const idPos = (pageWidth - idWidth) / 2;
  doc.text(ticket_number, idPos, 108);
  doc.setFontSize(8);
  const lastNameWidth = doc.getStringUnitWidth(lastName) * 8 * 0.3527;
  const lastNamePos = (pageWidth - lastNameWidth) / 2;
  doc.text(lastName, lastNamePos, 54);

  doc.setFontSize(10);
  doc.setFont("Inter", "bold");
  const firstNameWidth = doc.getStringUnitWidth(firstName) * 10 * 0.3527;
  const firstNamePos = (pageWidth - firstNameWidth) / 2;
  doc.text(firstName, firstNamePos, 58);

  doc.setFontSize(8);
  doc.setFont("Inter", "normal");

  const title = "ОУХ-ийн Найрамдал Цогцолбор";
  const eeljii1 = "Явах цэг: 5 Шар -";
  const eeljii2 = " Номин агуулахын талбай";
  const eeljii3 = " 09:30-с хөдөлнө";

  const eeljGoPosition = doc.getStringUnitWidth(eeljii1) * 8 * 0.3527;
  const eeljGoPosition1 = doc.getStringUnitWidth(eeljii2) * 8 * 0.3527;
  const eeljGoPosition2 = doc.getStringUnitWidth(eeljii3) * 8 * 0.3527;

  doc.text(eeljii1, (pageWidth - eeljGoPosition) / 2, 62);
  doc.text(eeljii2, (pageWidth - eeljGoPosition1) / 2, 65);
  doc.text(eeljii3, (pageWidth - eeljGoPosition2) / 2, 68);

  doc.addImage(header, "PNG", 4, 4, 46, 46);
  // doc.addImage(profile, "PNG", 12, 16, 30, 30);
  // doc.addImage("/ticket_dotslambo.png", "PNG", 0, 66, 54, 2);

  doc.setFontSize(8);
  doc.setFont("Inter", "normal");
  doc.setTextColor(70, 74, 152);
  const dateRange = `${eeljStartDate} - ${eeljEndDate}`;
  const eeljDateWidth = doc.getStringUnitWidth(dateRange) * 8 * 0.3527;

  const eeljDatePos = (pageWidth - eeljDateWidth) / 2;
  doc.text(dateRange , eeljDatePos, 73);

  // doc.setFontSize(8);
  // doc.setFont("Inter", "bold");
  // const fullnameWidth = doc.getStringUnitWidth(fullname) * 8 * 0.3527;
  // const fullnamePos = (pageWidth - fullnameWidth) / 2;
  // doc.text(fullname, fullnamePos, 198);

  doc.setFont("Inter", "normal");
  doc.setTextColor(0, 0, 0);
  const registerWidth = doc.getStringUnitWidth(register) * 8 * 0.3527;
  const registerPos = (pageWidth - registerWidth) / 2;
  doc.text(register, registerPos, 150);
  
  doc.addImage(imageData, "PNG", (pageWidth - 30) / 2, 112, 30, 30);


  doc.setFontSize(8);
  doc.setFont("Inter", "normal");

  const eeljTitleWidth = doc.getStringUnitWidth(eeljTitle) * 8 * 0.3527;
  const eeljTitlePos = (pageWidth - eeljTitleWidth) / 2;
  doc.text(eeljTitle, eeljTitlePos, 77);
  doc.addImage("/ticket_name_toplambo.png", "PNG", 0, 80, 54, 21);
  // doc.addImage(imageData, "PNG", (pageWidth - 30) / 2, 107.5, 30, 30);
  // doc.addImage("/ticket_namelambo.png", "PNG", 0, 142, 54, 20);
  // const titleWidth = doc.getStringUnitWidth(title) * 8 * 0.3527;
  // doc.setFont("Inter", "normal");
  // doc.setTextColor(70, 74, 152);
  // doc.text(title, (pageWidth - titleWidth) / 2 + titleWidth, 138, null, 180);


  if(ebarimt){
  const ebarimtQR = await QRCode.toCanvas(
    ebarimt.ebarimt_qr_data
  );

  const ebarimtQRData = ebarimtQR.toDataURL("image/png");
  const ebarimtPos = (pageWidth - registerWidth) / 2;

  doc.text("ИБаримт", ebarimtPos, 155);
  
  doc.text(ebarimt.amount, ebarimtPos, 192);
  doc.text(ebarimt.ebarimt_lottery, ebarimtPos, 195);
  
  doc.addImage(ebarimtQRData, "PNG", (pageWidth - 30) / 2, 158, 30, 30);


  doc.addImage("/ticket_name_bottomlambo.png", "PNG", 3, 190, 48, 10.5);
  }
  else {
    doc.addImage("/ticket_name_bottomlambo.png", "PNG", 3, 144, 48, 10.5);
  }
  doc.save(`Тасалбар - ${firstName}.pdf`);
}
export default {
  getImageDataURL,
  generatePDF,
};